import { cloneDeep } from "lodash";
import { ReportPlanCashFilterOptions } from "./options/ReportPlanCashFilterOptions";
import { allClassificationTypesOptions, allDataSourcesOptions, allPeriodicitiesOptions, allReportNamesOptions, allReportTypesOptions, allMutuallyRedeemingOptions, allStatusOptions, allBudgetTypesOptions, allMutuallyRedeemingLevelOptions, allMeasureUnitsOptions } from "../../common/baseOptions";
import { Indicator } from "../../common/types/Indicator";
import { ReportPlanCashFilterSettings } from "./settings/ReportPlanCashFilterSettings";
import { Template } from "../../common/types/Template";
import { Option } from "../../common/types/Option";
import { MeasureUnit } from "../../common/types/roots/fields";
import { Classificator } from "../../common/types/Classificator";

export const reportPlanCashIndicators: Indicator[] = [
    { key: 'action', active: false },
    { key: 'kat', active: false },
    { key: 'cls', active: false },
    { key: 'pcl', active: false },
    { key: 'spf', active: false },
    { key: 'region_name', active: true },
    { key: 'total_sum', active: true },
    { key: 'period_sum', active: true },
    { key: 'sumrg', active: true },
    { key: 'deviation_period', active: true },
    { key: 'percent_to_period', active: true },
    { key: 'deviation_annual', active: true },
    { key: 'percent_to_year', active: true },
    { key: 'sumrg_past', active: false },
    { key: 'deviation_past', active: false },
    { key: 'growth', active: false },
]

export const allPlanCashClassificators: Classificator[] = [
    { key: 'kat', active: true, selected: [1, 2, 3] },
    { key: 'cls', active: true, selected: [] },
    { key: 'pcl', active: true, selected: [] },
    { key: 'spf', active: true, selected: [] }
]


// Нужна как временная затычка (При созданий нового берутся пустые настройки)
const tempSettings: ReportPlanCashFilterSettings = {
    // Base:
    reportName: 'income_kbk',
    reportType: 'REGULATED',
    classificationType: 'INCOMES',
    measureUnit: 'TENGE',
    roundUpTo: null,
    // Custom:
    regions: [],
    dataSource: 'IISK',
    date: '',
    mutuallyRedeeming: 'WITHOUT',
    indicators: cloneDeep(reportPlanCashIndicators),
    incomes: cloneDeep(allPlanCashClassificators),
    statuses: ['39'],
    budgetTypes: [],
    mutuallyRedeemingLevels: [],
    sortByRegionCode: false
}

export const reportPlanCashBaseTemplate: Template = {
    id: null,
    name: 'Информация об исполнении доходов бюджета (план/касса)',
    excelName: null,
    description: null,
    category: '100',
    regions: [],
    userId: '',
    filterSettings: tempSettings
}


export const reportPlanCashFilterOptions: ReportPlanCashFilterOptions = {
    // Base:
    key: 'income_kbk',
    reportNames: cloneDeep(allReportNamesOptions),
    reportTypes: cloneDeep(allReportTypesOptions),
    classificationTypes: cloneDeep(allClassificationTypesOptions),
    dataSources: cloneDeep(allDataSourcesOptions.filter(it => it.value !== 'MIXED')),
    incomes: cloneDeep(allPlanCashClassificators),
    budgetTypes: cloneDeep(allBudgetTypesOptions).filter(it => it.value !== 1),
    // Custom:
    regions: [], // Загружается с бэка
    indicators: cloneDeep(reportPlanCashIndicators),
    mutuallyRedeeming: cloneDeep(allMutuallyRedeemingOptions),
    measureUnits: cloneDeep(allMeasureUnitsOptions),
    statuses: cloneDeep(allStatusOptions),
    mutuallyRedeemingLevels: cloneDeep(allMutuallyRedeemingLevelOptions)
}
